<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import Switch from 'dashboard/components-next/switch/Switch.vue';

const props = defineProps({
  campaign: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['edit', 'delete', 'toggle', 'report']);

const { t } = useI18n();

const formatDate = date => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString();
};

const formatTime = time => {
  if (!time) return '-';
  return time;
};
</script>

<template>
  <div
    class="bg-n-solid-1 border border-n-weak rounded-lg p-4 hover:shadow-md transition-shadow"
  >
    <div class="flex items-start justify-between gap-4">
      <!-- Image -->
      <div class="flex-shrink-0">
        <div
          v-if="campaign.image_url"
          class="w-16 h-16 rounded-lg overflow-hidden bg-n-alpha-2"
        >
          <img
            :src="campaign.image_url"
            :alt="campaign.title"
            class="w-full h-full object-cover"
          />
        </div>
        <div
          v-else
          class="w-16 h-16 rounded-lg bg-n-alpha-2 flex items-center justify-center"
        >
          <span class="i-lucide-image text-2xl text-n-slate-9" />
        </div>
      </div>

      <!-- Content -->
      <div class="flex-1 min-w-0">
        <div class="flex items-center gap-2 mb-1">
          <h3 class="text-base font-semibold text-n-slate-12 truncate">
            {{ campaign.title }}
          </h3>
        </div>

        <p class="text-sm text-n-slate-11 line-clamp-2 mb-2">
          {{ campaign.message }}
        </p>

        <div class="flex flex-wrap gap-4 text-xs text-n-slate-10">
          <div v-if="campaign.inbox" class="flex items-center gap-1">
            <span class="i-lucide-inbox" />
            <span>{{ campaign.inbox.name }}</span>
          </div>
          <div v-if="campaign.contact_list" class="flex items-center gap-1">
            <span class="i-lucide-users" />
            <span>{{ campaign.contact_list.name }} ({{
                campaign.contact_list.contacts_count
              }})</span>
          </div>
          <div class="flex items-center gap-1">
            <span class="i-lucide-calendar" />
            <span>{{ formatDate(campaign.start_date) }} -
              {{ formatDate(campaign.end_date) }}</span>
          </div>
          <div class="flex items-center gap-1">
            <span class="i-lucide-clock" />
            <span>{{ formatTime(campaign.start_time) }} -
              {{ formatTime(campaign.end_time) }}</span>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex items-center gap-2">
        <Switch
          :model-value="campaign.enabled"
          @update:model-value="emit('toggle')"
        />
        <Button
          icon="i-lucide-file-text"
          size="sm"
          variant="ghost"
          color="slate"
          title="Relatório de envios"
          @click="emit('report')"
        />
        <Button
          icon="i-lucide-pencil"
          size="sm"
          variant="ghost"
          color="slate"
          @click="emit('edit')"
        />
        <Button
          icon="i-lucide-trash-2"
          size="sm"
          variant="ghost"
          color="ruby"
          @click="emit('delete')"
        />
      </div>
    </div>
  </div>
</template>
